<template>
  <div class="flex flex-col h-full">
    <BlankHeader />
    <div class="flex h-full items-center justify-center"><slot></slot></div>
  </div>
</template>

<script setup lang="ts">
import BlankHeader from './components/BlankHeader.vue';
</script>
